import { Button, Stack, Step, StepLabel, Stepper } from '@mui/material'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import SelectDevice from '../../Devices/Components/SelectDevice'
import SelectTrackerForSite from '../Components/SelectTrackerForSite'
import TestSite from '../Components/TestSite'


const TestSiteSteps = () => {
  const [currentStep, setCurrentStep] = useState(0)
  const [enableButton, setEnableButton] = useState(false)
  const [trackerData, setTrackerData] = useState(null)
  const [deviceData, setDeviceData] = useState(null)
  const [isSuccess, setIsSuccess] = useState(null)
  const navigate = useNavigate()

  const showCurrentStep = () => {
    const steps = [
      <SelectDevice setDevice={setDeviceData} key={0} />,
      <SelectTrackerForSite tracker={trackerData} setTracker={setTrackerData} key={1} />,
      <TestSite tracker={trackerData} gateway={deviceData} setResult={setIsSuccess} key={2} />
    ]

    return steps[currentStep]
  }

  const handleNextStep = () => {
    if (currentStep >= 3) {
      navigate('select-test')
    }
    setEnableButton(false)
    setCurrentStep((prev) => prev + 1)
  }

  useEffect(() => {
    if (deviceData != null) {
      setEnableButton(true)
    }
  }, [deviceData])

  useEffect(() => {
    if (trackerData != null) {
      setEnableButton(true)
    }
  }, [trackerData])

  useEffect(() => {
    if (isSuccess != null) {
      setEnableButton(true)
    }
  }, [isSuccess])


  return (
    <Stack
      display="flex"
      flexDirection="column"
      alignItems="center"
      marginTop={5}
      width="100%"
      minHeight={'80vh'}>
      <Stepper activeStep={currentStep} alternativeLabel>
        <Step key="selectDevice">
          <StepLabel>Seleziona Dispositivo</StepLabel>
        </Step>
        <Step key="selectTracker">
          <StepLabel>Seleziona Tracker</StepLabel>
        </Step>
      </Stepper>

      {showCurrentStep()}

      <Button
        id="add-rule-dialog-button-save"
        variant={isSuccess ? 'text' : 'contained'}
        disabled={!enableButton}
        sx={{ mt: 'auto', width: '90%', marginBottom: '10px' }}
        onClick={handleNextStep}
      >
        {currentStep < 2 ? 'Avanti' : 'Non Salvare'}
      </Button>
    </Stack>
  )
}

export default TestSiteSteps
